export default "__VITE_ASSET__DOs1kjB0__"